import {RouteDefinition} from '../../../routes';
import {InputListScreen} from './InputListScreen';
import {InputEditScreen} from './InputEditScreen';

export const InputSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/input/edit',
        component: InputEditScreen,
    },
    {
        routerLink: '/settings/input/edit/:id',
        component: InputEditScreen,
    },
    {
        routerLink: '/settings/input',
        component: InputListScreen,
    },
];
